import React, { ReactNode, useState } from 'react';
import { EmptySchedulingDetails, SchedulingDetails } from '../../../api/models';

////////////////////////////
// Main context
////////////////////////////
export const SchedulingContext = React.createContext<SchedulingDetails>(
  EmptySchedulingDetails
);

////////////////////////////
// Update context
////////////////////////////
export interface SchedulingUpdateContextType {
  changeSchedulingDetails: (schedulingDetails: SchedulingDetails) => void;
}
const DummySchedulingUpdateContext = {
  // eslint-disable-next-line
  changeSchedulingDetails: (schedulingDetails: SchedulingDetails) => {},
};
export const SchedulingUpdateContext =
  React.createContext<SchedulingUpdateContextType>(
    DummySchedulingUpdateContext
  );

////////////////////////////
// wrapper component
////////////////////////////
interface SchedulingContextProviderProps {
  children: ReactNode;
}

export const SchedulingContextProvider: React.FC<
  SchedulingContextProviderProps
> = (props: SchedulingContextProviderProps) => {
  const [schedulingDetails, setSchedulingDetails] = useState<SchedulingDetails>(
    EmptySchedulingDetails
  );

  const changeSchedulingDetails = (schedulingDetails: SchedulingDetails) => {
    setSchedulingDetails(schedulingDetails);
  };

  return (
    <SchedulingContext.Provider value={schedulingDetails}>
      <SchedulingUpdateContext.Provider
        value={{ changeSchedulingDetails: changeSchedulingDetails }}
      >
        {props.children}
      </SchedulingUpdateContext.Provider>
    </SchedulingContext.Provider>
  );
};
